var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',_vm._l((_vm.mapVal),function(it,index){return _c('v-row',{key:_vm.getKey(it,index),attrs:{"no-gutters":""}},[(
        !_vm.mapKey[index].startsWith('id_') &&
          _vm.mapKey[index] != 'gid' &&
          _vm.mapKey[index] != 'id' &&
          _vm.mapKey[index] != 'createdAt' &&
          _vm.mapKey[index] != 'updatedAt'
      )?_c('p',{staticClass:"p-row"},[_vm._v("\n      "+_vm._s(_vm.capitalizeFirst(_vm.mapKey[index]))+":\n      "+_vm._s(_vm.formatItem(_vm.mapKey[index], _vm.mapVal[index]))+"\n    ")]):_vm._e()])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02cb5c04","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/table/DetailRow.vue
// module id = null
// module chunks = 